export enum AccessScope {
    ALL = 'all',
    OWN = 'own',
    NONE = 'none'
}
